import { TematicalColorButton } from "@/components/button/TematicalColorButton/TematicalColorButton";

import { DefaultLoader } from "@/components/loaders/DefaultLoader/DefaultLoader";
import { OverlayForNodeContent } from "@/components/modals/OverlayForNodeContent/OverlayForNodeContent";
import { DefaultScrollBarScroll } from "@/components/scrollbar/DefaultScrollBarScroll/DefaultScrollBarScroll";
import { reviewsStore } from "@/stores/ReviewsStore";
import { observer } from "mobx-react-lite";
import { Reply } from "../../Reply/Reply";
import { ReviewList } from "../ReviewList";
import styles from "./ListInPopup.module.css";

export const ListInPopup = observer(() => {
  return (
    reviewsStore.modal.openModal && (
      <OverlayForNodeContent
        modalData={reviewsStore.modal}
        utilsData={reviewsStore.utils}
        style={{
          width: reviewsStore.entity_type === "reply" ? "510px" : "86%",
          height: reviewsStore.entity_type === "reply" ? "400px" : "90dvh",
          maxWidth: "920px",
        }}
      >
        <div className={styles.popup}>
          <div className={styles.topHeader}>
            <span className="link-font">
              {reviewsStore.entity_type === "reply"
                ? "Ответ и одобрение отзыва"
                : `Отзывы - ${reviewsStore.name}`}
            </span>

            <TematicalColorButton onClick={() => reviewsStore.modal.isHide()}>Закрыть</TematicalColorButton>
          </div>
          <div className={styles.overlayScroll}>
            {reviewsStore.wait && <DefaultLoader elementIsReady={false} />}
            <div className={styles.scrollBox} data-lenis-prevent>
              {reviewsStore.entity_type === "reply" ? (
                <div className="!mt-5">
                  <div
                    className="
                    !relative
                    w-full md:w-[500px]
                    !my-5 
                    !p-2 
                    rounded-inherit 
                    
                    bg-[var(--global-bg-color))] 
                    border-1 
                    border-[rgba(0,0,0,0.55)] 
                    rounded 
                    before:content-[''] 
                    before:absolute 
                    before:top-0 
                    before:left-0 
                    before:w-full 
                    before:h-full
                    before:z-1
                    before:pointer-events-none
                    before:bg-[rgba(255,255,255,0.03)]
                 "
                  >
                    <Reply />
                  </div>
                </div>
              ) : (
                <ReviewList />
              )}
            </div>
            <DefaultScrollBarScroll />
          </div>
        </div>
      </OverlayForNodeContent>
    )
  );
});
